import Breadcrumbs from 'components/Common/Breadcrumb';
import Loader from 'components/Loader';
import MiniCards from 'components/MiniCard/mini-card';
import useRequest from 'hooks/useRequest';
import { useRouter } from 'hooks/useRouter';
import { isEmpty } from 'lodash';
import map from 'lodash/map';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Card, CardBody, Col, Container, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import { showImage } from 'utils/helper';
import SchoolClinicDoctors from './components/doctors';
import SchoolClinicOverview from './components/overview';
import SchoolClinicStudents from './components/students';

const SchoolClinicDetails = () => {
  const { query } = useRouter();
  toast.configure();

  const [schoolClinicsDetails, setSchoolClinicsDetails] = useState({});

  const tabsList = [
    {
      name: 'OverView',
      slug: 'overview',
      component: <SchoolClinicOverview schoolClinicsDetails={schoolClinicsDetails} />,
    },
    {
      name: 'Students',
      slug: 'students',
      component: <SchoolClinicStudents schoolClinicsDetails={schoolClinicsDetails} />,
    },
    {
      name: 'Doctors',
      slug: 'doctors',
      component: <SchoolClinicDoctors schoolClinicsDetails={schoolClinicsDetails} />,
    },
  ];

  const [activeTab, setActiveTab] = useState(query?.tab || tabsList[0]?.slug);

  const [getSchoolClinicRequest, { loading: getSchoolClinicLoading }] = useRequest({
    method: 'GET',
    onSuccess: (data) => {
      setSchoolClinicsDetails(data);
    },
  });

  const miniCards = [
    {
      title: 'Active',
      iconClass: 'bxs-message-rounded-dots',
      text: schoolClinicsDetails?.active ? 'Yes' : 'No',
      textColor: schoolClinicsDetails?.active ? 'text-success' : 'text-danger',
    },
    {
      title: 'Deleted',
      iconClass: 'bxs-message-rounded-dots',
      text: schoolClinicsDetails?.deleted ? 'Yes' : 'No',
      textColor: schoolClinicsDetails?.deleted ? 'text-success' : 'text-danger',
    },
  ];

  useEffect(() => {
    if (!isEmpty(query?.id)) {
      getSchoolClinicRequest({
        url: `/school-clinic/admin/${query?.id}`,
      });
    }
  }, [query]);

  return (
    <div className="page-content">
      <Loader isActive={getSchoolClinicLoading} />

      <Container fluid>
        <Breadcrumbs title="School Clinic" breadcrumbItem="School Clinic Details" />

        <Row>
          <Col xl="7">
            <Card className="overflow-hidden">
              <CardBody className="p-3">
                <Row className="align-items-center">
                  <Col sm="1" className="px-0">
                    <div className="avatar-md profile-user-wid m-auto d-flex align-items-center justify-content-center">
                      {!isEmpty(schoolClinicsDetails?.image) ? (
                        <img
                          src={showImage(schoolClinicsDetails?.image?.original)}
                          className="img-thumbnail rounded-circle"
                        />
                      ) : (
                        <i className="bx bx-first-aid" style={{ fontSize: '50px', color: '#3460BB' }} />
                      )}
                    </div>
                  </Col>
                  <Col sm="10" className="ms-4">
                    <h5 className="font-size-15 text-truncate mb-1">{schoolClinicsDetails?.name}</h5>
                    <p className="text-truncate mb-1">{schoolClinicsDetails?.healthcareFacility?.email}</p>
                    <p className="text-truncate mb-1">{schoolClinicsDetails?.healthcareFacility?.phoneNumber}</p>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>

          <Col xl="5">
            <Row>
              {map(miniCards, (card, key) => (
                <MiniCards
                  mdCol={6}
                  title={card?.title}
                  text={card?.text}
                  textColor={card?.textColor}
                  iconClass={card?.iconClass}
                  key={`_card_${key}`}
                  removeIcon={true}
                />
              ))}
            </Row>
          </Col>

          <div className="mt-2">
            <Nav tabs>
              {tabsList?.map((tab, index) => (
                <NavItem key={`_nav_${index}`}>
                  <NavLink
                    className={activeTab === tab?.slug ? 'active' : ''}
                    onClick={() => {
                      setActiveTab(tab?.slug);
                    }}>
                    {tab?.name}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
            <TabContent activeTab={activeTab}>
              {tabsList?.map((tab, index) => (
                <TabPane key={`tab_${index}`} tabId={tab?.slug}>
                  {tab?.component || ''}
                </TabPane>
              ))}
            </TabContent>
          </div>
        </Row>
      </Container>
    </div>
  );
};

export default SchoolClinicDetails;
